import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-payment-driver-create',
  templateUrl: './payment-driver-create.component.html',
  styleUrls: ['./payment-driver-create.component.css']
})
export class PaymentDriverCreateComponent implements OnInit {

  form: FormGroup;
  isChecked = false;

  constructor() { }

  ngOnInit(): void {
    this.createForm()
  }

  onSubmit() {
    console.log(this.form.value)
  }

  createForm() {
    this.form = new FormGroup({
      initialDate: new FormControl(),
      finalDate: new FormControl(),
      driver: new FormControl(),
      description: new FormControl(),
      releaseType: new FormControl(),
      value: new FormControl(),
      paymentType: new FormControl(),
      bank: new FormControl()
    })
  }

}
